import React, { useState, useEffect } from 'react';
import { Prompt } from 'react-router-dom';

const useUnsavedChangesWarning = (
  message = 'WARNING: This page contains unsaved changes. Do you still wish to leave this page?',
) => {
  const [isDirty, setDirty] = useState(false);

  useEffect(() => {
    // Detecting browser closing
    if (isDirty) {
      window.onbeforeunload = () => {
        sessionStorage.removeItem('modifiedWindowsFields');
      };
    }
    window.onbeforeunload = isDirty
      ? () => {
        return isDirty && !!message;
      }
      : null;

    return () => {
      window.removeEventListener('beforeunload', () => {});
    };
  }, [isDirty, message]);

  const routerPrompt = <Prompt when={isDirty} message={message} />;
  const onDirty = () => setDirty(true);
  const onPristine = () => setDirty(false);

  return { routerPrompt, onDirty, onPristine };
};

export default useUnsavedChangesWarning;

export const useDropdown = ({ dropDownData }) => {
  return (option, typeCode) => {
    const options = dropDownData && dropDownData[typeCode] ? dropDownData[typeCode] : [];
    let label = {};
    options &&
      options.length > 0 &&
      options.forEach((item) => {
        if (item?.valueCode === option?.toString() || item?.value === option?.toString()) {
          label = item;
        }
      });
    return label;
  };
};
